const APP_VERSION = '0.2.1' as const;
const APP_RELEASE_CHANNEL = 'release' as const;

const APP_VERSION_LABEL = `v${APP_VERSION}` as const;

type AppVersionSnapshot = {
  version: typeof APP_VERSION;
  releaseChannel: typeof APP_RELEASE_CHANNEL;
  displayLabel: typeof APP_VERSION_LABEL;
};

const getAppVersionSnapshot = (): AppVersionSnapshot => ({
  version: APP_VERSION,
  releaseChannel: APP_RELEASE_CHANNEL,
  displayLabel: APP_VERSION_LABEL
});

export {
  APP_VERSION,
  APP_RELEASE_CHANNEL,
  APP_VERSION_LABEL,
  getAppVersionSnapshot
};
export type { AppVersionSnapshot };
